// removed by extract-text-webpack-plugin
module.exports = {"box":"ListBox__box__RFa3X","title":"ListBox__title__1chlN","items":"ListBox__items__DCL_3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Partners/Mobile/ListBox.scss
// module id = 463
// module chunks = 0